export default () => {
  const podcastElements = document.querySelectorAll('.podcast');
  podcastElements.forEach((podcast) => {
    const html = htmlToElement(podcast.innerHTML)
    podcast.insertAdjacentHTML('beforeBegin',`${html.data}`);
  });

  function htmlToElement(html) {
    const template = document.createElement('template');
    html = html.trim(); // Never return a text node of whitespace as the result
    template.innerHTML = html;
    return template.content.firstChild;
  }

  const scrollBtn = document.querySelector('#scroll-btn');
  if (scrollBtn) {
    const handleScroll = () => {
      if (window.scrollY < 1800) {
        scrollBtn.classList.remove('show');
      } else {
        scrollBtn.classList.add('show');
      }
    }

    window.addEventListener('scroll', handleScroll);

    scrollBtn.addEventListener('click', ()=> {
      window.scrollTo({top: 0, behavior: 'smooth'});
    });
  }
}